// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1lXAD","sendOtp":"AuthorizeToLogin_sendOtp__3o9kV"};